const CurrentTitle = ({
  title,
}: {
  title: string;
}) => (
  <div className="form-title-public__title">{title}</div>
);

export default CurrentTitle;